import { render, staticRenderFns } from "./EditsTariffModal.vue?vue&type=template&id=45a1c708"
import script from "./EditsTariffModal.vue?vue&type=script&lang=js"
export * from "./EditsTariffModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports